import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"; // Use Routes instead of Switch
import "./App.scss";
import Main from "./containers/Main";

// Resume Viewer Component
const ResumeViewer = () => (
  <iframe
    src="/Srimonchaari_Padmanabhan_Babu_Resume.pdf"
    title="Srimonchaari Resume"
    width="100%"
    height="100vh"
    style={{border: "none"}}
  />
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Replace Switch with Routes, and update Route components */}
        <Route path="/" element={<Main />} />
        <Route path="/resume" element={<ResumeViewer />} />
      </Routes>
    </Router>
  );
}

export default App;
